import axios, { AxiosInstance } from 'axios';
import { env } from '../config/env';

export const apiClient: AxiosInstance = axios.create({
  baseURL: env.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add Bearer token
apiClient.interceptors.request.use(
  (config) => {
    // Get token from OIDC context (stored in sessionStorage by oidc-client-ts)
    const oidcStorage = sessionStorage.getItem(`oidc.user:${env.OIDC_AUTHORITY}:${env.OIDC_CLIENT_ID}`);

    if (oidcStorage) {
      const user = JSON.parse(oidcStorage);
      if (user && user.access_token) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - trigger re-login
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
